// extracted by mini-css-extract-plugin
export default {"list":"RulesList_list__LZ5m5","item":"RulesList_item__Gntkk","button_delete":"RulesList_button_delete__jtstF"};